<template>
	<Page>
		<Calculator :tab="$route.params.tab" />
	</Page>
</template>

<script>
import Page from '@/layouts/Page'
import Calculator from '@/components/Calculator'

export default {
	name: 'CalculatorView',
	components: {
		Page,
		Calculator
	}
}
</script>
